import { useLoaderData } from "react-router";
import SimpleFormPage from "../common/SimpleFormPage";
import EmployeeFields from "./EmployeeFields";

export default function EditEmployee() {
  const employee = useLoaderData();
  return (
    <SimpleFormPage
      title="Modifica dipendente"
      loadFn={(form) =>
        form.setFieldsValue({
          ...employee,
          mansion: employee.mansion?.id ?? null,
        })
      }
    >
      <EmployeeFields />
    </SimpleFormPage>
  );
}
